export default [
  { id: "1", imageName: "item_01.jpg", tag: "residential" },
  { id: "2", imageName: "item_02.jpg", tag: "commercial" },
  { id: "3", imageName: "item_03.jpeg", tag: "residential" },
  { id: "4", imageName: "item_04.jpeg", tag: "roof" },
  { id: "5", imageName: "item_05.jpg", tag: "roof" },
];
